// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   CommunityImpact — Section between ProofAndCredibility and Map
   ============================================================ */

.ci {
  background: var(--c-cream);
  padding-top: var(--section-y);
  padding-bottom: clamp(4rem, 8vw, 7rem);
  position: relative;
  overflow: hidden;
  /* border-top: 1px solid var(--line); */
}

/* ── Inner container ────────────────────────────────────────── */
.ci__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: clamp(2.5rem, 5vw, 4rem);
  position: relative;
  z-index: 1;
}

/* ══════════════════════════════════════════════════════════════
   HEADER — centred stack
══════════════════════════════════════════════════════════════ */
.ci__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.9rem;
  text-align: center;
  max-width: 54rem;
}

/* Eyebrow */
.ci__eyebrow {
  /* u-eyebrow applied via className */
  color: var(--accent);
  letter-spacing: 0.26em;
}

/* Logo + horizontal rules */
.ci__logo-divider {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  width: 100%;
  justify-content: center;
}

.ci__logo-rule {
  display: block;
  flex: 1 1;
  max-width: 4rem;
  height: 1px;
  background: var(--accent);
  opacity: 0.5;
}

.ci__logo-mark {
  width: clamp(20px, 2.5vw, 28px);
  height: auto;
  flex-shrink: 0;
}

/* Headline */
.ci__headline {
  font-size: clamp(2.6rem, 6.5vw, 6rem);
  color: var(--c-forest);
  line-height: 0.92;
  letter-spacing: -0.01em;
  margin: 0;
}

/* Short rust rule under headline */
.ci__head-rule {
  display: block;
  width: clamp(2.5rem, 5vw, 4rem);
  height: 2px;
  background: var(--accent);
  opacity: 0.7;
}

/* Sub-copy */
.ci__sub {
  font-family: var(--font-serif);
  font-style: italic;
  font-size: clamp(0.95rem, 1.5vw, 1.2rem);
  color: var(--text-muted);
  line-height: 1.65;
  margin: 0;
}

/* ══════════════════════════════════════════════════════════════
   SIX-COLUMN CARD GRID
══════════════════════════════════════════════════════════════ */
.ci__grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: clamp(0.75rem, 1.5vw, 1.25rem);
  width: 100%;
}

/* ── Individual card ── */
.ci__card {
  background: var(--c-cream);
  border: 1px solid rgba(27, 27, 27, 0.12);
  border-radius: var(--radius);
  padding: clamp(1.25rem, 2vw, 1.75rem) clamp(1rem, 1.5vw, 1.4rem);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  position: relative;
  overflow: hidden;
  /* very subtle texture shadow */
  box-shadow: 0 2px 12px rgba(27, 27, 27, 0.05);
  transition:
    box-shadow 0.35s var(--ease),
    transform 0.35s var(--ease);
}

.ci__card:hover {
  box-shadow: 0 8px 28px rgba(27, 27, 27, 0.1);
  transform: translateY(-3px);
}

/* Icon circle */
.ci__card-icon {
  width: clamp(46px, 5.5vw, 64px);
  height: clamp(46px, 5.5vw, 64px);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  /* Icon SVG size */
  padding: clamp(10px, 1.2vw, 14px);
}

.ci__card-icon svg {
  width: 100%;
  height: 100%;
}

/* Big animated number */
.ci__card-num {
  font-family: var(--font-serif);
  font-weight: 400;
  font-size: clamp(2rem, 4vw, 3.2rem);
  line-height: 1;
  letter-spacing: -0.01em;
  /* color set inline per card */
}

/* Label + underline */
.ci__card-label-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.ci__card-label {
  font-family: var(--font-body);
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  margin: 0;
  line-height: 1;
  /* color set inline */
}

.ci__card-rule {
  display: block;
  width: clamp(1.5rem, 2.5vw, 2.25rem);
  height: 2px;
  /* background set inline */
  opacity: 0.6;
}

/* Description */
.ci__card-desc {
  font-family: var(--font-body);
  font-size: clamp(0.72rem, 0.9vw, 0.82rem);
  color: var(--text-muted);
  line-height: 1.58;
  margin: 0;
  flex: 1 1;
}

/* Bottom accent rule */
.ci__card-bottom-rule {
  display: block;
  width: clamp(1.5rem, 2.5vw, 2rem);
  height: 2px;
  opacity: 0.35;
  margin-top: auto;
}

/* ══════════════════════════════════════════════════════════════
   CTA BUTTON
══════════════════════════════════════════════════════════════ */
.ci__cta-wrap {
  display: flex;
  justify-content: center;
}

.ci__cta {
  display: inline-flex;
  align-items: center;
  gap: 0.85rem;
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--accent);
  text-decoration: none;
  border: 1.5px solid var(--accent);
  padding: 1rem clamp(2rem, 5vw, 3.5rem);
  border-radius: var(--radius-sm);
  transition:
    background var(--dur) var(--ease),
    color var(--dur) var(--ease),
    gap var(--dur) var(--ease);
}

.ci__cta:hover {
  background: var(--accent);
  color: var(--on-accent);
  gap: 1.1rem;
}

.ci__cta-icon {
  font-size: 0.7rem;
  transition: transform var(--dur) var(--ease);
}
.ci__cta:hover .ci__cta-icon {
  transform: translateX(3px);
}

/* ══════════════════════════════════════════════════════════════
   DECORATIVE CORNERS
══════════════════════════════════════════════════════════════ */

/* Botanical leaf — bottom-left */
.ci__botanical {
  position: absolute;
  bottom: -1rem;
  left: -2rem;
  width: clamp(120px, 16vw, 220px);
  pointer-events: none;
  z-index: 0;
}

.ci__botanical img {
  width: 100%;
  height: auto;
  display: block;
}

/* Badge + mountains — bottom-right */
.ci__badge-corner {
  position: absolute;
  bottom: 1rem;
  right: clamp(1rem, 3vw, 3rem);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
  pointer-events: none;
  z-index: 0;
}

/* Scale badge down to subtle corner accent */

.ci__badge-mtn {
  width: clamp(196px, 29vw, 278px);
  height: auto;
  margin-top: -0.5rem;
}

/* ══════════════════════════════════════════════════════════════
   RESPONSIVE
══════════════════════════════════════════════════════════════ */

@media (max-width: 1199.98px) {
  .ci__grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 767.98px) {
  .ci__grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .ci__botanical {
    display: none;
  }
  .ci__badge-corner {
    display: none;
  }
  .ci__headline {
    font-size: clamp(2.2rem, 10vw, 3.5rem);
  }
}

@media (max-width: 479.98px) {
  .ci__grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/CommunityImpact.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA,kEAAkE;AAClE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,oCAAoC;EACpC,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,SAAO;EACP,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,qCAAqC;EACrC,sBAAsB;EACtB,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;AACX;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,+BAA+B;EAC/B,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,4BAA4B;EAC5B,gEAAgE;EAChE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,6CAA6C;EAC7C;;+BAE6B;AAC/B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;EACd,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,SAAS;EACT,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,WAAW;EACX,0BAA0B;EAC1B,YAAY;AACd;;AAEA,gBAAgB;AAChB;EACE,6BAA6B;EAC7B,yCAAyC;EACzC,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;EACT,SAAO;AACT;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,iCAAiC;EACjC,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;EACjC,sCAAsC;EACtC,+BAA+B;EAC/B;;;8BAG4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,4CAA4C;AAC9C;AACA;EACE,0BAA0B;AAC5B;;AAEA;;gEAEgE;;AAEhE,iCAAiC;AACjC;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gCAAgC;EAChC,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA,6CAA6C;;AAE7C;EACE,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;gEAEgE;;AAEhE;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ============================================================\n   CommunityImpact — Section between ProofAndCredibility and Map\n   ============================================================ */\n\n.ci {\n  background: var(--c-cream);\n  padding-top: var(--section-y);\n  padding-bottom: clamp(4rem, 8vw, 7rem);\n  position: relative;\n  overflow: hidden;\n  /* border-top: 1px solid var(--line); */\n}\n\n/* ── Inner container ────────────────────────────────────────── */\n.ci__inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: clamp(2.5rem, 5vw, 4rem);\n  position: relative;\n  z-index: 1;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   HEADER — centred stack\n══════════════════════════════════════════════════════════════ */\n.ci__header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.9rem;\n  text-align: center;\n  max-width: 54rem;\n}\n\n/* Eyebrow */\n.ci__eyebrow {\n  /* u-eyebrow applied via className */\n  color: var(--accent);\n  letter-spacing: 0.26em;\n}\n\n/* Logo + horizontal rules */\n.ci__logo-divider {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  width: 100%;\n  justify-content: center;\n}\n\n.ci__logo-rule {\n  display: block;\n  flex: 1;\n  max-width: 4rem;\n  height: 1px;\n  background: var(--accent);\n  opacity: 0.5;\n}\n\n.ci__logo-mark {\n  width: clamp(20px, 2.5vw, 28px);\n  height: auto;\n  flex-shrink: 0;\n}\n\n/* Headline */\n.ci__headline {\n  font-size: clamp(2.6rem, 6.5vw, 6rem);\n  color: var(--c-forest);\n  line-height: 0.92;\n  letter-spacing: -0.01em;\n  margin: 0;\n}\n\n/* Short rust rule under headline */\n.ci__head-rule {\n  display: block;\n  width: clamp(2.5rem, 5vw, 4rem);\n  height: 2px;\n  background: var(--accent);\n  opacity: 0.7;\n}\n\n/* Sub-copy */\n.ci__sub {\n  font-family: var(--font-serif);\n  font-style: italic;\n  font-size: clamp(0.95rem, 1.5vw, 1.2rem);\n  color: var(--text-muted);\n  line-height: 1.65;\n  margin: 0;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   SIX-COLUMN CARD GRID\n══════════════════════════════════════════════════════════════ */\n.ci__grid {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  gap: clamp(0.75rem, 1.5vw, 1.25rem);\n  width: 100%;\n}\n\n/* ── Individual card ── */\n.ci__card {\n  background: var(--c-cream);\n  border: 1px solid rgba(27, 27, 27, 0.12);\n  border-radius: var(--radius);\n  padding: clamp(1.25rem, 2vw, 1.75rem) clamp(1rem, 1.5vw, 1.4rem);\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  position: relative;\n  overflow: hidden;\n  /* very subtle texture shadow */\n  box-shadow: 0 2px 12px rgba(27, 27, 27, 0.05);\n  transition:\n    box-shadow 0.35s var(--ease),\n    transform 0.35s var(--ease);\n}\n\n.ci__card:hover {\n  box-shadow: 0 8px 28px rgba(27, 27, 27, 0.1);\n  transform: translateY(-3px);\n}\n\n/* Icon circle */\n.ci__card-icon {\n  width: clamp(46px, 5.5vw, 64px);\n  height: clamp(46px, 5.5vw, 64px);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #fff;\n  /* Icon SVG size */\n  padding: clamp(10px, 1.2vw, 14px);\n}\n\n.ci__card-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n/* Big animated number */\n.ci__card-num {\n  font-family: var(--font-serif);\n  font-weight: 400;\n  font-size: clamp(2rem, 4vw, 3.2rem);\n  line-height: 1;\n  letter-spacing: -0.01em;\n  /* color set inline per card */\n}\n\n/* Label + underline */\n.ci__card-label-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.ci__card-label {\n  font-family: var(--font-body);\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  margin: 0;\n  line-height: 1;\n  /* color set inline */\n}\n\n.ci__card-rule {\n  display: block;\n  width: clamp(1.5rem, 2.5vw, 2.25rem);\n  height: 2px;\n  /* background set inline */\n  opacity: 0.6;\n}\n\n/* Description */\n.ci__card-desc {\n  font-family: var(--font-body);\n  font-size: clamp(0.72rem, 0.9vw, 0.82rem);\n  color: var(--text-muted);\n  line-height: 1.58;\n  margin: 0;\n  flex: 1;\n}\n\n/* Bottom accent rule */\n.ci__card-bottom-rule {\n  display: block;\n  width: clamp(1.5rem, 2.5vw, 2rem);\n  height: 2px;\n  opacity: 0.35;\n  margin-top: auto;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   CTA BUTTON\n══════════════════════════════════════════════════════════════ */\n.ci__cta-wrap {\n  display: flex;\n  justify-content: center;\n}\n\n.ci__cta {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.85rem;\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: 0.72rem;\n  letter-spacing: 0.22em;\n  text-transform: uppercase;\n  color: var(--accent);\n  text-decoration: none;\n  border: 1.5px solid var(--accent);\n  padding: 1rem clamp(2rem, 5vw, 3.5rem);\n  border-radius: var(--radius-sm);\n  transition:\n    background var(--dur) var(--ease),\n    color var(--dur) var(--ease),\n    gap var(--dur) var(--ease);\n}\n\n.ci__cta:hover {\n  background: var(--accent);\n  color: var(--on-accent);\n  gap: 1.1rem;\n}\n\n.ci__cta-icon {\n  font-size: 0.7rem;\n  transition: transform var(--dur) var(--ease);\n}\n.ci__cta:hover .ci__cta-icon {\n  transform: translateX(3px);\n}\n\n/* ══════════════════════════════════════════════════════════════\n   DECORATIVE CORNERS\n══════════════════════════════════════════════════════════════ */\n\n/* Botanical leaf — bottom-left */\n.ci__botanical {\n  position: absolute;\n  bottom: -1rem;\n  left: -2rem;\n  width: clamp(120px, 16vw, 220px);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.ci__botanical img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Badge + mountains — bottom-right */\n.ci__badge-corner {\n  position: absolute;\n  bottom: 1rem;\n  right: clamp(1rem, 3vw, 3rem);\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 0.25rem;\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Scale badge down to subtle corner accent */\n\n.ci__badge-mtn {\n  width: clamp(196px, 29vw, 278px);\n  height: auto;\n  margin-top: -0.5rem;\n}\n\n/* ══════════════════════════════════════════════════════════════\n   RESPONSIVE\n══════════════════════════════════════════════════════════════ */\n\n@media (max-width: 1199.98px) {\n  .ci__grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 767.98px) {\n  .ci__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .ci__botanical {\n    display: none;\n  }\n  .ci__badge-corner {\n    display: none;\n  }\n  .ci__headline {\n    font-size: clamp(2.2rem, 10vw, 3.5rem);\n  }\n}\n\n@media (max-width: 479.98px) {\n  .ci__grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
